/**
 * [营业执照]
 * @author: Fu Xiaochun
 * @date: 2022-05-30 
 */

import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';
import { Input, Select, message, DatePicker, Checkbox  } from 'antd';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import moment from 'moment';

function BusinessLicense(props, ref){

    // 营业执照
    const [licenseImg, setLicenseImg] = useState();  // 营业执照图片
    const [businessLicenseId, setBusinessLicenseId] = useState(); // 营业执照号码
    const [businessLicenseName, setBusinessLicenseName] = useState(); // 企业名称
    const [expirationTime, setExpirationTime] = useState(''); // 营业执照有效期
    const [permanent, setPermanent] = useState(false);  // 是否营业执照长期有效

    const fileChange = (data = {})=>{
        let imgs;
        if(Array.isArray(data.fileList)){
            data.fileList.forEach(v=>{
                if(v.status == 'success'){
                    imgs = v;
                }
            });
        }
        setLicenseImg(imgs);
    };

    const disabledDate = (current) => {
        return current && current < moment().endOf('day');
    };

    useImperativeHandle(ref, ()=>({
        getState: ()=>{
            return {
                licenseImg: licenseImg?.url,
                businessLicenseId,
                businessLicenseName,
                expirationTime: permanent ? undefined : expirationTime,
                permanent,
            };
        }
    }));

    return (
        <div className={styles.businessLicense}>
            <div className={styles.leftBox}>
                <div className={styles.licenseCard}>
                    <CusotmUpload accept='.png, .jpg, .jpeg' listType='picture-card' wallMode='single'
                        fileList={licenseImg ? [licenseImg] : null}
                        onFileListChange={fileChange}
                        removeError
                        qiniuUploadProps={{uploadType: 'image'}}
                        beforeUpload={file => {
                            const isType = ['image/png', 'image/jpeg', 'image/jpg'];
                            const isLt5M = file.size / 1024 / 1024 > 5;
                            if (!isType.includes(file.type)) {
                                message.warn('只能上传png,jpg, jpeg格式的图片!');
                                file.status = 'error';
                                return false;
                            } else if (isLt5M) {
                                message.warn('图片必须小于 5MB!');
                                file.status = 'error';
                                return false;
                            }
                        }}
                    >
                        <div style={{ color: '#999999', fontSize: '16px' }}>上传营业执照</div>
                    </CusotmUpload>
                </div>
                <div className={styles.extTxt}>支持JPG、JPEG、PNG格式，大小不超过5M。证件照片需清晰、完整，不能有遮挡，不能出现无关水印</div>
            </div>
            <div className={styles.rightBox}>
                <div className={styles.item}>
                    <div className={styles.label}>营业执照号码：</div>
                    <div className={styles.val}>
                        <Input className={styles.txt} allowClear value={businessLicenseId} placeholder="请输入营业执照号码" maxLength={30} onChange={e=>{setBusinessLicenseId(e.target.value.trim());}} />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>企业名称：</div>
                    <div className={styles.val}>
                        <Input className={styles.txt} allowClear value={businessLicenseName} placeholder="请输入企业名称" maxLength={20} onChange={e=>{setBusinessLicenseName(e.target.value.trim());}} />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>执照有效期：</div>
                    <div className={styles.val}>
                        <DatePicker className={styles.txt} disabled={permanent} disabledDate={disabledDate} value={expirationTime ? moment(expirationTime, 'YYYY-MM-DD') : ''} onChange={(date, dateStr)=>{setExpirationTime(dateStr);}} format={'YYYY-MM-DD'} />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}></div>
                    <div className={styles.val}>
                        <Checkbox onChange={e=>{setPermanent(e.target.checked);}}>长期有效</Checkbox>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(BusinessLicense);